/**
 * @zirro/editor — canvas, inspector, layer tree, selection, drag/drop,
 * history, responsive controls (PRD §101).
 */

import "./editor.css";

export const EDITOR_VERSION = "0.1.0";

export type SaveStatus = "saved" | "saving" | "unsaved" | "error";
export type Viewport = "desktop" | "tablet" | "mobile";

export const VIEWPORT_WIDTHS: Record<Viewport, number> = {
  desktop: 1280,
  tablet: 768,
  mobile: 375,
};

export {
  useEditorStore,
  saveDraftToStorage,
  loadDraftFromStorage,
  type EditorState,
  type PageLayoutOption,
  type LeftTab,
  type InspectorTab,
} from "./store";

export { EditorLayout, type EditorLayoutProps } from "./components/EditorLayout";
export { TopBar, type TopBarProps } from "./components/TopBar";
export { ZirroMark } from "./components/ZirroMark";
export { LeftSidebar } from "./components/LeftSidebar";
export { PagesTab } from "./components/PagesTab";
export { AddTab } from "./components/AddTab";
export { LayersTab } from "./components/LayersTab";
export { Canvas } from "./components/Canvas";
export { RightInspector } from "./components/RightInspector";
export { InspectorContent } from "./components/InspectorContent";
export { InspectorStyle } from "./components/InspectorStyle";
export { InspectorTheme } from "./components/InspectorTheme";
export { MediaLibraryModal, type MediaAsset } from "./components/MediaLibraryModal";

export { useAutosave, type UseAutosaveOptions } from "./hooks/useAutosave";
export { useKeyboardShortcuts } from "./hooks/useKeyboardShortcuts";

export {
  findNodeById,
  cloneNodeWithNewIds,
  updateNodePropsInDocument,
  addNodeToDocument,
  removeNodeFromDocument,
  duplicateNodeInDocument,
  moveNodeInDocument,
  type NodeSearchResult,
} from "./tree-utils";
